import { svg } from "@opentiny/vue-common";
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 126 151",
      "xml:space": "preserve"
    }
  }, _vm.$listeners), [_c("path", {
    attrs: {
      "d": "M112.524 12.653 75.041 62.736l-.023 74.905 12.502 12.484V62.736l37.507-50.083V.193H.002v12.46L37.51 62.736v62.42l12.502 12.485V62.736L12.505 12.653z"
    }
  })]);
};
var Unfilter = {
  render
};
var index = function index2() {
  return svg({
    name: "IconUnfilter",
    component: Unfilter
  })();
};
export {
  index as default
};
